/*
 * Knuska footer - the folding columns.
 *
 * The stylesheet owns the accordion: what it looks like shut, what it looks
 * like open, how it travels between the two, and the fact that none of it
 * applies above 768px. All that is left here is the open attribute and the
 * state a screen reader is told, which is why there is so little of it.
 *
 * The same media query is written in both places. It has to be: CSS cannot
 * tell script what it decided, and a button that says "collapsed" over a
 * column standing open in a four-column grid is worse than no button at all.
 */
const KNUSKA_FOOTER_FOLD_QUERY = '(max-width: 768px)';

class KnuskaFooterFold extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.knuska-footer__fold-btn');
    if (!this.button) return;

    this.media = window.matchMedia(KNUSKA_FOOTER_FOLD_QUERY);

    this.button.addEventListener('click', () => this.toggle());
    this.media.addEventListener('change', () => this.sync());
    this.sync();
  }

  toggle() {
    // The wide layout leaves the button inert in CSS; this is the same answer
    // for anything that reaches it another way - a keyboard, an extension.
    if (!this.media.matches) return;

    this.toggleAttribute('open');
    this.sync();
  }

  sync() {
    if (this.media.matches) {
      this.button.setAttribute('aria-expanded', this.hasAttribute('open') ? 'true' : 'false');
      this.button.removeAttribute('tabindex');
      return;
    }

    /*
     * Above the breakpoint the column is simply open, and the heading is a
     * heading again. Saying so, rather than dropping the attributes, keeps the
     * button honest about the content it still points at - and taking it out
     * of the tab order stops it collecting a stop on every page for a control
     * that cannot do anything at this width.
     */
    this.button.setAttribute('aria-expanded', 'true');
    this.button.setAttribute('tabindex', '-1');
  }
}

if (!customElements.get('knuska-footer-fold')) {
  customElements.define('knuska-footer-fold', KnuskaFooterFold);
}
